import { PlanningModel } from "../Models/PlanningModel";
import { useContact, useProperty } from '@/OneLiners';
import { ActionResponse, ActionStatusHelper, RecordMap, useAuditEnricher } from "@/Shared";

export function usePlanningEnricher() {

    const { stateResponse: contactResponse,  dataMap: contactMap } = useContact();
    const { dataMap: propertyMap, stateResponse: propertyResponse } = useProperty();


    /**
             * Centralized audit enrichment hook
             * - Provides O(1) user resolution via precomputed Map
             * - Exposes audit enrichment helpers and status/error
             */
    const {
        enricherResponse: auditEnricherResponse,
        userMap,
        getUserById,
        getEnrichedAudit,
    } = useAuditEnricher<PlanningModel>();

    const enricherResponse: ActionResponse = {
        status: ActionStatusHelper.combine(
            propertyResponse.status,
            contactResponse.status,
            auditEnricherResponse.status
        ),
        error: propertyResponse.error ??
            contactResponse.error ??
            auditEnricherResponse.error
    };

     const getEnrichedPlanningMap = (planningMap: RecordMap<PlanningModel>): RecordMap<PlanningModel> => {
                
                return planningMap.map<PlanningModel>(getStrictEnrichedPlanning);
            }


    const getEnrichedPlanning = (planning?: PlanningModel): PlanningModel | undefined => {
        return planning ? getStrictEnrichedPlanning(planning) : undefined;
    }

    const getStrictEnrichedPlanning = (planning: PlanningModel) => {
        return {
            ...getEnrichedAudit(planning),
            contact: planning.contactId ? contactMap.get(planning.contactId) : undefined,
            agent: userMap.get(planning.agentId),
            property: planning.propertyId ? propertyMap.get(planning.propertyId) : undefined,
        }
    }

    const getEnrichedPlanningById = (planningMap: Map<number, PlanningModel>,
        planningId: number): PlanningModel | undefined => {
        return getEnrichedPlanning(planningMap.get(planningId));
    }

    return {
        contactMap,
        userMap,
        propertyMap,
        enricherResponse,
        getEnrichedPlanning,
        getStrictEnrichedPlanning,
        getEnrichedPlanningById,
        getEnrichedPlanningMap
    }
}